import createSagaMiddleware from 'redux-saga';
import { compose, createStore, applyMiddleware } from 'redux';
import { persistStore } from 'redux-persist';

import { createBrowserHistory as createHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';

import { hasTruthyConditions } from './utils';

export const configStore = (
  rootReducers,
  rootSagas,
  reduxTools,
  projectPersistConfigs,
) => {
  const sagaMiddleware = createSagaMiddleware();
  const history = createHistory();

  let composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  if (!reduxTools) {
    composeEnhancers = compose;
  }
  const preloadedState = window.__PRELOADED_STATE__;
  delete window.__PRELOADED_STATE__;

  const executePersistConfigurations = rootReducers(history);
  const hasValidConditions =
    projectPersistConfigs && hasTruthyConditions(projectPersistConfigs);

  let reducers;
  let shouldPersist;

  if (hasValidConditions) {
    [reducers, shouldPersist] = executePersistConfigurations(
      history,
      projectPersistConfigs,
      true,
      true,
    );
  } else {
    reducers = executePersistConfigurations(undefined, undefined, true);
  }

  const mystore = createStore(
    reducers,
    preloadedState,
    composeEnhancers(
      applyMiddleware(sagaMiddleware, routerMiddleware(history)),
    ),
  );

  sagaMiddleware.run(rootSagas);

  return {
    store: mystore,
    history,
    persistor: shouldPersist && persistStore(mystore),
  };
};
